import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import Redirect from '../../../../common/components/Redirect';

const LoginRedirect = ({ returnUrl, message }) => {
  const loginUrl = url.parse(window.location.href);
  loginUrl.pathname = '/auth/login';
  if (returnUrl) {
    loginUrl.query = { returnUrl, message };
  }

  return <Redirect external to={url.format(loginUrl)} />;
};

LoginRedirect.propTypes = {
  returnUrl: PropTypes.string,
  message: PropTypes.string,
};

export default LoginRedirect;



// WEBPACK FOOTER //
// ./src/App/account/components/LoginRedirect/index.js